export enum ObjectTag {
  Watermark = "Watermark",
  AdamSource = "AdamSource",
  AdamTrailer = "AdamTrailer",
}
